import { render } from "./CollapsibleTriangle.vue?vue&type=template&id=2fb080b8&scoped=true"
import script from "./CollapsibleTriangle.vue?vue&type=script&lang=ts"
export * from "./CollapsibleTriangle.vue?vue&type=script&lang=ts"

import "./CollapsibleTriangle.vue?vue&type=style&index=0&id=2fb080b8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fb080b8"

export default script